import React from 'react'

const ExpandIcon = ({
  onClick,
}: {
  onClick?: (e: React.MouseEvent) => void
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <g clip-path="url(#clip0_2612_4527)">
        <path
          d="M15 13.75V6.25C15 5.55964 14.4404 5 13.75 5H6.25C5.55964 5 5 5.55964 5 6.25V13.75C5 14.4404 5.55964 15 6.25 15H13.75C14.4404 15 15 14.4404 15 13.75Z"
          stroke="#1890FF"
          stroke-width="1.3"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M1.25 12.5V18.75H7.5"
          stroke="#1890FF"
          stroke-width="1.3"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M18.75 7.5V1.25H12.5"
          stroke="#1890FF"
          stroke-width="1.3"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_2612_4527">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ExpandIcon
